var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReindeerBody(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 34,
    viewBox: "0 0 25 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6609 23C12.4243 23 7.77803 24 6.1095 24.5C4.79787 26.2032 2.82713 29.237 1 33H23.4366C21.4514 28.4356 19.2899 24.8509 17.6609 23Z",
    fill: "#C68B61",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.091 24C12.3082 24 8.06464 24.9 6.54071 25.35C5.34275 26.8829 3.54281 29.6133 1.87402 33H22.6665C20.8534 28.8921 18.5788 25.6658 17.091 24Z",
    fill: "#C68B61",
    stroke: "#C68B61",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41376 7.92932C9.5114 9.65088 10.4308 10.9011 10.8783 11.311C11.3665 13.2785 10.2681 14.5901 9.65785 15C0.0159919 9.77384 3.18926 1.31974 4.89795 1.01232C6.60663 0.704903 4.89795 6.2385 7.21688 7.62187C8.15929 8.18407 7.70507 3.62543 8.55941 3.47172C9.41376 3.31801 9.29171 5.77737 9.41376 7.92932Z",
    fill: "#854E16",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.388 7.92932C17.3025 9.65088 16.498 10.9011 16.1064 11.311C15.6793 13.2785 16.6404 14.5901 17.1744 15C25.611 9.77384 22.8344 1.31974 21.3393 1.01232C19.8442 0.704903 21.3393 6.2385 19.3102 7.62187C18.4856 8.18407 18.8831 3.62543 18.1355 3.47172C17.388 3.31801 17.4948 5.77737 17.388 7.92932Z",
    fill: "#854E16",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27748 11C3.47748 9.40002 6.77748 11.6667 8.27748 13C8.44415 13.6667 8.47748 15 7.27748 15C5.77748 15 0.777483 13 2.27748 11Z",
    fill: "#C58A60",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77747 14C6.6108 13 4.17747 11.2 3.77747 12C3.37747 12.8 6.27747 13.6667 7.77747 14Z",
    fill: "#814D14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.862 11C22.662 9.40002 19.362 11.6667 17.862 13C17.6954 13.6667 17.662 15 18.862 15C20.362 15 25.362 13 23.862 11Z",
    fill: "#C58A60",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3621 14C19.5287 13 21.9621 11.2 22.3621 12C22.7621 12.8 19.8621 13.6667 18.3621 14Z",
    fill: "#814D14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9095 11C20.7216 11 26.3152 30 12.9097 30C-2.09664 30 4.62302 11 12.9095 11Z",
    fill: "#C68B61",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25.2105C19.854 27.3158 16.6748 29.5 12.573 29.5C8.4712 29.5 5.34911 26.8947 5 25.2105C5 22.8851 8.4712 21 12.573 21C16.6748 21 20 22.8851 20 25.2105Z",
    fill: "#F1C3A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 24.5789C14.5 24.766 14.3879 24.9818 14.0287 25.1773C13.6693 25.373 13.1325 25.5 12.5 25.5C11.8675 25.5 11.3307 25.373 10.9713 25.1773C10.6121 24.9818 10.5 24.766 10.5 24.5789C10.5 24.375 10.632 24.1171 10.9992 23.8852C11.3601 23.6573 11.8893 23.5 12.5 23.5C13.1107 23.5 13.6399 23.6573 14.0008 23.8852C14.368 24.1171 14.5 24.375 14.5 24.5789Z",
    fill: "#C82039",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 17.5,
    r: 0.5,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 17.5,
    r: 0.5,
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27C12.2 27.4 12.5 26.5 12.5 26C12.5 26.5 12.8 27.4 14 27",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReindeerBody);
export default __webpack_public_path__ + "static/media/reindeer-body.e5fbd8c17808617f971b0be3836f2ee9.svg";
export { ForwardRef as ReactComponent };